module.exports = __webpack_public_path__ + "assets/img/13.4b226075.png";